import React, { useState, useContext, useRef } from 'react'
import styles from './Prefecture.module.css'
import { NextButton } from '../../../Common/CtaButton/NextButton'
import { BackButton } from '../../../Common/CtaButton/BackButton'
import { StepContext } from '@/components/Context/StepContext'
import { PrefectureProps } from './types'
import { useAbTestGtm } from '@/components/utils/abTest'
import { FollowIcon } from '../../../FormGuidance/FollowIcon'
import { useFollowIcon } from '../../../FormGuidance/FollowIcon/useFollowIcon'

export const Prefecture = ({ prefectures, gtmTags }: PrefectureProps) => {
    const { handleNext, handlePrev, updateFormData, formData, isCurrentStepValid, isAnimating, currentStep } = useContext(StepContext)

    const parentRef = useRef<HTMLDivElement>(null)
    const titleRef = useRef<HTMLDivElement>(null)
    const inputGroupRef = useRef<HTMLDivElement>(null)
    const nextButtonRef = useRef<HTMLDivElement>(null)
    const [isOpen, setIsOpen] = useState(false)
    const targets = [
        // ドロップダウンが開かれたら（isOpen）or 選択済みならtitleを通過
        { ref: titleRef, isComplete: isOpen || !!formData.prefecture },
        // 都道府県が選択されたらinputGroupを通過
        { ref: inputGroupRef, isComplete: !!formData.prefecture, offset: 46 },
        { ref: nextButtonRef, isComplete: isCurrentStepValid },
    ]
    const { iconStyle } = useFollowIcon({ parentRef, targets, isAnimating, layoutKey: currentStep })
    const [displayFormData, setDisplayFormData] = useState('')
    const handleSelectClick = () => {
        setIsOpen(!isOpen)
    }

    const handleOptionSelect = (value, displayValue) => {
        updateFormData('prefecture', value)
        setDisplayFormData(displayValue)
        setIsOpen(false)
    }

    const handleNextClick = () => {
        if (formData.prefecture) {
            handleNext()
        }
    }

    const { dataViewLabel, dataClickLabel } = useAbTestGtm()

    return (
        <div className={styles.wrapper} ref={parentRef} data-view-label={dataViewLabel(gtmTags.dataViewLabel)}>
            <FollowIcon iconStyle={iconStyle} />
            <div className={styles.title} ref={titleRef}>
                <BackButton dataClickLabel={dataClickLabel(gtmTags.dataClickLabels.back)} onClick={handlePrev} />
                <h2
                    className={styles.titleText}
                >
                    Q.現在のお住まいは？
                </h2>
            </div>

            <div className={styles.inputGroup} ref={inputGroupRef}>
                <div className={styles.labelWrapper}>
                    <label className={styles.label}>都道府県</label>
                    <span className={styles.required}>必須</span>
                </div>

                <div className={styles.selectWrapper}>
                    <div
                        className={`${styles.customSelect} ${formData.prefecture ? styles.selected : ''}`}
                        onClick={handleSelectClick}
                    >
                        <span>{displayFormData || '都道府県を選んでください'}</span>
                        <div className={styles.selectArrow}>
                            <img
                                src='/entry_form_slide_app/common/selectArrow.png'
                                alt='選択矢印'
                            />
                        </div>
                    </div>
                    {isOpen && (
                        <div className={styles.optionsContainer}>
                            {prefectures.map((prefecture, index) => (
                                <div
                                    key={index}
                                    className={styles.optionItem}
                                    onClick={() => handleOptionSelect(prefecture[1], prefecture[0])}
                                >
                                    {prefecture[0]}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>

            <NextButton
                ref={nextButtonRef}
                disabled={!formData.prefecture}
                dataClickLabel={dataClickLabel(gtmTags.dataClickLabels.next)}
                onClick={handleNextClick}
            />
        </div>
    )
}
